import { PledgePaymentAuthorization } from "@evergiving/common/dist/es2015/pledge";

export interface PledgePaymentAuthorizationState {
  token: string;
  authorization: PledgePaymentAuthorization;
}

export const looksLikeAnAuthorization = (
  input: unknown
): input is PledgePaymentAuthorization => {
  if (typeof input !== "object" || input === null) {
    return false;
  }

  const candidate = input as Partial<PledgePaymentAuthorization>;

  return (
    candidate.version === 1 &&
    typeof candidate.pledgeId === "number" &&
    typeof candidate.expiresAt === "string" &&
    typeof candidate.frequency === "string" &&
    typeof candidate.amount === "object" &&
    candidate.amount !== null &&
    typeof candidate.amount.value === "number" &&
    typeof candidate.amount.currency === "string"
  );
};
